









































import { GeekItem } from '@/models';
import { Opportunity, OpportunityActions, OpportunityMembershipStatus } from '@/models/opportunities';
import { ToastsService, buildGeekFullName } from '@/utils';
import { Actions } from '@/store';
import Vue from 'vue';

export default Vue.extend({
  name: 'RejectCandidateModal',
  props: {
    geek: Object as () => GeekItem,
    opportunity: Object as () => Opportunity,
  },
  data() {
    return {
      reason: '',
      loader: {
        isRequestPending: false,
      },
    };
  },
  computed: {
    geekName(): string {
      return buildGeekFullName(this.geek);
    },
  },
  methods: {
    async rejectCandidate() {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }

      this.loader.isRequestPending = true;
      try {
        await this.$store.dispatch(
          Actions.opportunities.changeCandidateStatus,
          {
            opportunityId: this.opportunity.id,
            geekId: this.geek.id,
            status: OpportunityMembershipStatus.Rejected,
            reason: this.reason,
          },
        );

        const toastText =
          this.$t('opportunities.details.notifications.status-change',
            {
              status: this.$t('opportunities.membershipStatuses.rejected'),
              firstName: this.geek.firstName,
              nick: this.geek.nick,
              lastName: this.geek.lastName,
            },
          ) as string;
        ToastsService.warning(toastText);
        this.$bvModal.hide('reject-candidate-modal');
        this.$emit('refresh');
      } finally {
        this.loader.isRequestPending = false;
      }
    },
    resetModal() {
      this.reason = '';
    },
    buildGeekFullName,
  },
});
